<script>
  import {
    format,
  } from '@/helpers';
  import Icon from '@/components/Icon';
  import IconClose from '@/assets/icon-close.svg';

  export default {
    components: {
      Icon,
      IconClose,
    },

    props: {
      coin: {
        type: String,
        required: true,
      },

      initial: {
        type: String,
        required: true,
      },

      sell: {
        type: Boolean,
        required: false,
        default: false,
      },

      price: {
        type: Number,
        required: true,
      },

      type: {
        type: String,
        required: true,
      },
    },

    mounted () {
      const timeout = setTimeout(() => this.$emit('dismiss'), 5000);

      this.$once('hook:destroyed', () => clearTimeout(timeout));
    },

    computed: {
      percent () {
        return Math.floor(Math.random() * 100);
      },

      executed () {
        return format(
          this.price * (this.percent / 100)
        );
      },

      formated () {
        return format(this.price);
      },
    },
  };
</script>

<template>
  <div
    class="transaction-notification"
    >
    <div class="transaction-notification__icon">
      <Icon :icon="coin" />

      <span
        class="transaction-notification__type"
        :class="{ 'transaction-notification__type--sell': sell }"
        v-text="sell ? 'V' : 'C'"
      >
      </span>
    </div>

    <div class="transaction-notification__content">
      <h4 class="transaction-notification__title">
        {{ sell ? 'Venda' : 'Compra' }} realizada com sucesso!

        <button
          @click.prevent="$emit('dismiss')"
          class="transaction-notification__close"
        >
          <IconClose />
        </button>
      </h4>

      <ul class="transaction-notification__list">
        <li class="transaction-notification__item">
          Tipo: <span v-text="type"></span>
        </li>

        <li class="transaction-notification__item">
          Valor executado: <span>0,00006000 {{ initial }} <strong>({{ percent }}%)</strong> </span>
        </li>

        <li class="transaction-notification__item">
          Preço unitário: <span v-text="formated"></span>
        </li>
      </ul>
    </div>

    <span class="transaction-notification__bar"></span>
  </div>
</template>

<style lang="scss">
  .transaction-notification {
    width: 540px;
    display: flex;
    padding: 40px;
    position: relative;
    border-radius: 4px;
    background-color: #26283f;
    box-shadow: 0 16px 32px -8px rgba(#26283f, 0.4);

    &__icon {
      position: relative;

      svg {
        height: 69px;
        width: 63.3px;
      }
    }

    &__type {
      top: 42px;
      width: 32px;
      height: 32px;
      right: -10px;
      color: #FFF;
      display: flex;
      line-height: 1;
      position: absolute;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      background-color: #509e02;

      &--sell {
        background-color: #d0021b;
      }
    }

    &__title {
      display: flex;
      line-height: 1.5;
      color: #b2b8c5;
      margin-bottom: 8px;
      align-items: center;
      letter-spacing: .32px;
      justify-content: space-between;
    }

    &__item {
      color: #FFF;
      display: flex;
      font-size: 14px;
      margin-top: 16px;
      line-height: 1.14;
      justify-content: space-between;

      span {
        color: #b2b8c5;
        letter-spacing: .28px;
      }

      strong {
        font-weight: 500;
      }
    }

    &__content {
      flex: 1;
      display: flex;
      margin-left: 24px;
      flex-direction: column;
    }

    &__bar {
      left: 0;
      bottom: 0;
      width: 0%;
      height: 4px;
      position: absolute;
      border-radius: 2px;
      background-color: #3e388b;
      animation: width_full 5s linear;
    }
  }
</style>
